<template>
  <div class="home">
    <Header />
    <Topic
      :scroll-top="scrollTop"
      @dialogVisible="onDialogChange"
    />
    <Section1 />
    <Section2
      :coach-list="coachList"
    />
    <Section3 />
    <Section4 />
    <Section5 />
    <Section6 />
    <Section7 />
    <Section8 />
    <Section9 />

    <div class="flat-qrcode">
      <img
        src="../assets/float-btn.png"
        srcset="../assets/float-btn@2x.png 2x"
      >
      <img
        class="qrcode"
        src="../assets/float-code.png"
        srcset="../assets/float-code@2x.png 2x"
      >
    </div>
  </div>
</template>

<script>
import { throttle } from 'throttle-debounce';
import cookie from '@front-end/utils/lib/cookie';
import Header from '@/components/Header.vue';
import Topic from '@/components/Topic.vue';
import Section1 from '@/components/Section1.vue';
import Section2 from '@/components/Section2-1.vue';
import Section3 from '@/components/Section3.vue';
import Section4 from '@/components/Section4.vue';
import Section5 from '@/components/Section5.vue';
import Section6 from '@/components/Section6.vue';
import Section7 from '@/components/Section7.vue';
import Section8 from '@/components/Section8.vue';
import Section9 from '@/components/Section9.vue';
import coach2 from '@/assets/coach-2.png';
import coach3 from '@/assets/coach-3.png';
import { device, setShare } from '@/utils';

export default {
  name: 'Home',
  components: {
    Header,
    Topic,
    Section1,
    Section2,
    Section3,
    Section4,
    Section5,
    Section6,
    Section7,
    Section8,
    Section9,
  },
  data() {
    return {
      coachList: [
        {
          img: coach2,
          name: '黄教练·Ben',
          title: 'TTPS交易系统创始人/主讲九大策略/交易认知和风控构建',
          intro: [
            '10年外汇市场经验，8年实战教学经验。前TOP2大型经纪商首席中文分析师。长期供稿东方财富、腾讯证券、和讯网等知名投资门户。精通价格行为（PriceActionTrading）和图形识别(pattern recognition)，擅长G7直盘货币和黄金基本面分析，专注于日内和波段交易。',
          ],
        },
        {
          img: coach3,
          name: '杰明',
          title: '主讲基本面底层逻辑、剖析行业内幕',
          intro: [
            '7年交易经验，5年外汇衍生品从业经历。曾任某深圳TOP4大型私募基金衍生品交易员，某台湾外汇经纪商首席分析师与台湾知名投研机构IMAS策略开发师。精通外汇行业运作细节，擅长把握宏观大类资产的轮动走势，结合技术面择时进场抓取波段收益。',
          ],
        },
      ],
      scrollTop: 0,
    };
  },
  mounted() {
    setShare({
      title: 'TTPS交易系统 | 跑赢市场 超额收益',
      content: 'TTPS以欧美职业交易员的裸K价格行为体系为基础，经8年实战和复盘深度优化，连交易小白也可轻松复制。注意：内含限时100%免费课程。',
    });

    this.handleScroll = throttle(500, () => {
      const classList = ['section-1', 'section-2', 'section-3', 'section-4', 'section-5', 'section-6', 'section-7', 'section-8', 'section-9'];
      classList.forEach((item) => {
        // 当内容出现 1/3 时展示动画
        const dom = document.querySelector(`.${item}`);
        const { innerHeight } = window;
        const top = dom.offsetTop - (document.documentElement.scrollTop || document.body.scrollTop);
        this.scrollTop = (document.documentElement.scrollTop || document.body.scrollTop);

        if (top < innerHeight) {
          dom.classList.add('active');
        }
      });
    });

    document.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.handleScroll);
    clearInterval(this.timer);
  },
  methods: {
    goPage() {
      cookie.set('TTPS_TYPE', 'B');

      const URL = 'https://www.wjx.top/jq/100236113.aspx';
      if (device.isMobile) {
        window.open(URL, '_self');
      } else {
        window.open(URL);
      }
    },
    onDialogChange() {
      this.$store.dispatch('changeQrcode', '2');
      this.$store.dispatch('changeContactVisible', true);
    },
  },
};
</script>

<style lang="scss" scoped>
.flat-qrcode {
  position: fixed;
  z-index: 3;
  right: percentage(105px / 1920px);
  bottom: 144px;
  width: percentage(103px / 1920px);
  min-width: 86px;
  max-width: 104px;
  cursor: pointer;
  vertical-align: middle;

  img {
    display: block;
    width: 100%;
  }

  .qrcode {
    position: absolute;
    left: 50%;
    bottom: 0;
    margin-bottom: percentage(112px / 103px);
    transform: translate(-50%, 10px);
    width: percentage(209px / 103px);
    opacity: 0;
    transition: all .3s;
    visibility: hidden;
  }

  &:hover .qrcode {
    opacity: 1;
    transform: translate(-50%, 0);
    visibility: visible;
  }

  @include mediaWidth(#{$mbWidth}) {
    display: none;
  }
}
</style>
